import {html} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import B2bElement from '../../../b2b-element.js';
import B2bPublicServiceClientProxy from '../../../gen/com/arabellesolutions/sdc/b2b/pub/B2bPublicServiceClientProxy.js';
import defaultStyle from '../../b2b-public-styles.scss';
import style from './b2b-public-sso-selection.scss';
import ExternalUser from "../../../gen/com/arabellesolutions/sdc/b2b/common/user/ExternalUser.js";
import {map} from "lit/directives/map.js";

@customElement('b2b-public-sso-selection')
export class B2bPublicSsoSelection extends B2bElement {
  static styles = [defaultStyle, style];

  /** @type {ExternalUser} */
  @property({type: ExternalUser, attribute: false})
  accessor user;

  @property({type: Object, attribute: false})
  accessor route;

  /** @type {String} */
  @state()
  accessor __appId;

  @state()
  accessor __app;

  /** @type {String[]} */
  @state()
  accessor __usernames = [];

  __b2bPublicServiceProxy = new B2bPublicServiceClientProxy(super.msgpackClientPublic());

  render() {
    if (!this.user) {
      return html`<h1>Loading</h1>`;
    }
    const appIdInt = parseInt(this.__appId, 10);
    ({ application: this.__app, users: this.__usernames } = this.getAppAndUsernames(this.user, appIdInt));

    return html`
      <mta-page-title page-name="ssoSelection" title="SSO Selection"></mta-page-title>
      <section class="sso-selection">
          <h2>Sign in ${this.__app.name}</h2>
          <p>${this.__usernames.length > 1 
              ? 'You have more than one account for this application. Select the account you want to use:'
              : 'Continue with the account below to sign in.'}</p>
          <div class="sso-grid">
              ${map(this.__usernames, username => html`
                    <mta-datacard-light class="sso-card" as-button
                                        card-title="${username}"
                                        @click="${() => this.redirectToApp(username)}">
                    </mta-datacard-light>
                `)}
          </div>
      </section>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.__appId = this.route.args.code;
  }

  getAppAndUsernames(user, appId) {
    const accessesForApp = user.applicationAccesses.filter(access => access.idApp === appId);
    if (accessesForApp.length === 0) {
      return { application: null, users: [] };
    }
    const application = accessesForApp[0].app;

    const users = accessesForApp
      .map(access => access.username);

    return { application, users };
  }

  redirectToApp(username) {
    this.__b2bPublicServiceProxy.selectUsername(username)
      .then(r => window.location.replace(`${this.__app.applicationUrl}`));
  }
}
